import React from 'react';
import PropTypes from 'prop-types';
import LikesList from './likesList';
import CommentsList from './commentsList';
import LikeButton from './likeButton';
import UserAvatar from './userAvatar';
import EntryActivities from './entryActivities';
import EntryPhotos from './entryPhotos';
import { find } from 'lodash';

const EntriesItem = (props) => {
  const currentUserLike = find(props.entry.likes, (like) => {
    return like.user.id === props.currentUser.id;
  });
  const handleCommentFormSubmitted = (newCommentText) => props.onCreateComment(props.entry, newCommentText);
  const handleCreateLike = (likeType) => props.onCreateLike(props.entry, likeType);
  const handleDestroyLike = (like) => props.onDestroyLike(props.entry, like);

  return (
    <li>
      <UserAvatar user={props.entry.user} />
      {props.entry.photos.length > 0 && <EntryPhotos photos={props.entry.photos} />}
      {props.entry.activities.length > 0 && <EntryActivities entry={props.entry} />}
      <div>
        <p>{props.entry.message}</p> 
        <span>{props.entry.createdAt.toLocaleTimeString()}</span>
      </div>
      {(props.entry.user.id !== props.currentUser.id) && 
        <LikeButton likeLoadingStatus={props.entryLikeStatus} likeTypes={props.likeTypes} currentUserLike={currentUserLike} onLiked={handleCreateLike} onUnliked={handleDestroyLike} />}
      <LikesList likes={props.entry.likes} currentUserLike={currentUserLike} />
      <CommentsList comments={props.entry.comments} onCommentFormSubmitted={handleCommentFormSubmitted} commentStatus={props.entryCommentStatus} />
    </li>
  );
}

EntriesItem.propTypes = {
  currentUser: PropTypes.object.isRequired,
  entry: PropTypes.object.isRequired,
  likeTypes: PropTypes.array.isRequired,
  entryCommentStatus: PropTypes.string,
  entryLikeStatus: PropTypes.string,
  onCreateComment: PropTypes.func.isRequired,
  onCreateLike: PropTypes.func.isRequired,
  onDestroyLike: PropTypes.func.isRequired
};

export default EntriesItem;


// WEBPACK FOOTER //
// ./src/views/entryItem.js